<template>
<div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="zmpp_con w1200">
      <div class="hxq_yzjk_mbx" style="padding-left: 0px">
        <a href="/" class="allResult">首页<span class="newspan">></span></a>帮助中心
      </div>
      <div class="demo-image__preview" style="width:100%;display: inline-block;">
        <!--左侧导航开始-->
        <div>
          <LeftNavs :leftNavis='11'/>
        </div>
        <!--左侧导航结束-->
        <div class="cght_htmainrights">
          <div class="loading-wrap">
            <div class="content-title-wrap">
              <div class="content-title">运费政策</div>
            </div>
            <div class="loading-box">
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content"><i class="el-icon-s-order"></i></div>
                  </div>
                  <div class="n_right_head">
                    <p>运费政策</p>
                  </div>
                </div>
                <div class="n-content">
                  <p class="no_indent">运费收取规则：</p>
                  <p class="no_indent">1）
                    <span class="red-t">特殊商品</span>
                    ：该类商品运费收取适用在其详情页公示的特殊规则。如商品详情页无特殊规则，则适用本运费规则。
                  </p>
                  <p class="no_indent">2）
                    <span class="red-t">普通商品</span>
                    ：订单（不含特殊商品、服务类商品及其他非实物商品）含税金额
                    <span class="red-t">满300元免收运费</span>
                    ；不满300元的，
                    <span class="red-t">偏远地区</span>
                    （新疆维吾尔自治区、宁夏回族自治区、西藏自治区、青海省、海南省、港澳台）按照
                    <span class="red-t">50元/单</span>
                    收取运费，除偏远地区外的
                    <span class="red-t">其他国内地区</span>
                    按照<span class="red-t">8元/单</span>
                    收取运费。
                  </p>
                  <p class="no_indent">3）同一订单中既包括普通商品又包括特殊商品的，两类商品按照其对应的运费收取规则分别计算，互不叠加。</p>
                  <p class="no_indent">4）服务类商品及其他非实物商品订单免收运费。</p>
                  <p class="no_indent">注1：计算运费的订单金额以订单最终实际支付金额为准。</p>
                  <p class="no_indent">注2：运费的收取规则可能进行相应调整，具体以商品详情页及官网公示为准。</p>
                  <br>
                  <p class="no_indent">针对退换货的运费：</p>
                  <p class="no_indent">1）若退换货是由志鹏供应链原因导致，则针对退换货部分的来回运费由志鹏供应链承担；</p>
                  <p class="no_indent">2）若退换货是由客户原因导致，则针对退换货部分的来回运费由客户自行承担；(若仅退货，则仅需要承担退回部分运费）</p>
                  <p class="no_indent">3）具体退换货规则，<router-link :to="{path:'/Returngoods'}" class="link_href">请参见志鹏供应链售后政策部分。</router-link></p>
                  <p class="no_indent">如有任何疑问，请拨打志鹏供应链热线电话：400-040-7890 我们将竭诚为您服务。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import LeftNavs from '@/components/Help/Left_navs'

export default {
  name: 'Help',
  components: {
    Header,
    Navigationzj,
    Footer,
    LeftNavs
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.cght_htmainrights .loading-wrap {
  margin-left: 252px;
  top: 0;
  left: 0;
  right: 0;
}
.loading-wrap .content-title-wrap {
  height: 42px;
  background: #f7f7f7;
}
.loading-wrap .content-title-wrap .content-title {
  float: left;
  width: auto;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #666;
  line-height: 42px;
  margin-left: 16px;
}
.loading-wrap .loading-box {
  background-size: 74px auto;
  border-left: 1px dashed #e8e8e8;
  margin-left: 43px;
  margin-top: 25px;
  margin-bottom: 40px;
  height: auto;
}
.n_right_line {
  padding-bottom: 40px;
}
.n_right_line .n_title_line {
  text-align: left;
  margin-left: -30px;
}
.n_right_line .n_title_line .icon-background {
  float: left;
  margin-left: 10px;
  margin-right: 11px;
  width: 40px;
  height: 40px;
  background-color: #436aa6;
  border-radius: 50%;
}
.loading-wrap .loading-box :last-child {
  padding-bottom: 0;
}
.n_right_line .n_title_line .icon-background .icon-content {
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.n_right_line .n_title_line .n_right_head {
  display: inline-block;
  margin-left: 21px;
  margin-top: 10px;
}
.n_right_line .n_title_line .n_right_head p {
  font-size: 18px;
  color: #333;
  line-height: 20px;
  margin-bottom: 6px;
}
.n_right_line .n_title_line .n_right_head span {
  display: inline;
  font-size: 14px;
  color: #666;
  line-height: 20px;
}
.n_right_line .n_content {
  margin-top: 20px;
  margin-left: 45px;
  text-align: left;
}
.n_right_line .n_content img {
  width: 855px;
}
.n_right_line .n-content {
  margin-top: 30px;
  margin-left: 45px;
  text-align: left;
  text-indent: 10px;
  font-size: 14px;
  text-indent: 2em;
  line-height: 30px;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/view/help/freight.vue